import { DateTime } from 'luxon';
import videojs from 'video.js';

const TimeTooltip = videojs.getComponent('TimeTooltip');

/**
 * Formats milliseconds to HH:mm:ss format using Luxon
 */
function formatTimeToHHmmss(milliseconds: number, tz: string): string {
  return DateTime.fromMillis(milliseconds).setZone(tz).toFormat('HH:mm:ss');
}

/**
 * Converts HH:mm:ss format string to seconds
 * @param timeString - Time string in HH:mm:ss format
 * @returns Time in seconds
 */
function parseHHmmssToSeconds(timeString: string): number {
  const parts = timeString.split(':').map(Number);

  if (parts.length !== 3 || parts.some(isNaN)) {
    return 0;
  }

  const [hours, minutes, seconds] = parts;
  return hours * 3600 + minutes * 60 + seconds;
}

const original = (TimeTooltip.prototype as any).write;
(TimeTooltip.prototype as any).write = function (content: string) {
  const player = this.player();
  const playerEl = player.el();

  // Check if data-initial-time attribute exists
  const initialTimeAttr = playerEl.getAttribute('data-time-from');
  const timeTzAttr = playerEl.getAttribute('data-time-tz');

  if (initialTimeAttr) {
    const initialTimeMs = parseFloat(initialTimeAttr);

    if (!isNaN(initialTimeMs)) {
      // initialTime is a JS timestamp in milliseconds
      // content contains duration in HH:mm:ss format, convert to seconds then milliseconds
      const currentTime = parseHHmmssToSeconds(content);
      const currentTimeMs = currentTime * 1000;
      const adjustedTimeMs = initialTimeMs + currentTimeMs;
      const formattedTime = formatTimeToHHmmss(adjustedTimeMs, timeTzAttr);

      return original.call(this, formattedTime);
    }
  }

  return original.call(this, content);
};
